<template>
  <v-container fluid class="pa-0 pa-md-2">
    <v-breadcrumbs large :items="breadcrumbs"></v-breadcrumbs>
    <router-view></router-view>
  </v-container>
</template>

<script>
import breadcrumbs from '@/utils/breadcrumbs';

export default {
  name: 'EntityMain',
  computed: {
    breadcrumbs() {
      return breadcrumbs(this.$route);
    },
  },
};
</script>
